export namespace StringUtils {
  export const getArticle = (word: string) => {
    return ["a", "e", "i", "o", "u"].includes(word[0].toLowerCase()) ? "an" : "a";
  };

  export const containsCaseInsensitive = (str: string, substr: string) => {
    return str.toLowerCase().includes(substr.toLowerCase());
  };

  export const getLastCharacter = (str: string) => {
    return str[str.length - 1] ?? "";
  };
}
